export const EDUCATION_PLACE = '/education_place/'
export const EDUCATION_PLACE_ALL = `${EDUCATION_PLACE}all`
